/**
 * @ngdoc module
 * @name vrm.core
 * @description VRM core module
 */

(function () {
    'use strict';

    angular.module('vrm.core')
        .config(/* @ngInject */ function ($stateProvider) {

            // set available routes
            $stateProvider
                .state('base.admin', {
                    abstract: true,
                    url: '/admin',
                    views: {
                        "main": {
                            template: require('@/angular/views/core/admin/admin.html'),
                            controller: 'AdminController'
                        }
                    },
                    resolve: {
                        checkUserIsAdmin: ['$q', '$state', 'UserService', 'vrmUserAccessLevel',
                            function ($q, $state, UserService, vrmUserAccessLevel) {
                                return UserService.getUser().then(function(user) {
                                    if (user.accessLevel !== vrmUserAccessLevel.ADMIN && user.accessLevel !== vrmUserAccessLevel.RESTRICTED_ADMIN) {
                                        $q.reject("Not authorized");
                                        $state.go('base.installation-overview');
                                    }
                                });
                            }]
                    }

                });

        });

})();
